import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import ScrollArea from "react-scrollbar";

const ServiceHighlight = ({highlight, scrollable}) => {

    const html = useMemo(() => {

        let parser = new DOMParser();
        const doc = parser.parseFromString(highlight, "text/html");

        doc.querySelectorAll(':not(p) > br').forEach(ele => {
            // check for any p tag in parent level
            if (!ele.closest('p'))
                ele.remove()
        })
        return doc.body.outerHTML;
    }, [highlight]);
    const table = (
        <div dangerouslySetInnerHTML={{ __html: html }}>

        </div>
    );

    return (
        <div className="pyo-tab-details">

            <div className="pyo-detail-table">

                {
                    scrollable ? (
                        <ScrollArea
                            speed={0.8}
                            className="area"
                            smoothScrolling={true}
                            contentClassName="scroll-area"
                            stopScrollPropagation={true}
                            horizontal={false}>

                            <div className="mx-5">{table}</div>

                        </ScrollArea>
                    ) : <div className="mx-5">{table}</div>

                }

            </div>
        </div>
    );
}

ServiceHighlight.propTypes = {
    highlight: PropTypes.any,
    scrollable: PropTypes.bool,
};

export default ServiceHighlight;